import { ConfirmModal } from '../../components/ConfirmModal';
import './OrganizationTrial.css';

interface ConvertTrialModalProps {
  isOpen: boolean;
  organizationName: string;
  loading: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Confirms recording that an organization became a paying customer.
 *
 * **The copy is plain about this being a one-way door.** There is no unconvert: the way back is to
 * clear the trial and enter the dates again, which drops the window that was there. A confirm that
 * only asked "are you sure" would imply this is as reversible as pausing, and it is not. The same
 * sentence is on the panel behind it, so the decision can be made before the dialog opens.
 */
export const ConvertTrialModal = ({
  isOpen,
  organizationName,
  loading,
  error,
  onConfirm,
  onClose,
}: ConvertTrialModalProps) => (
  <ConfirmModal
    isOpen={isOpen}
    title="Mark as converted"
    message={`Mark "${organizationName}" as converted? This records that they became a paying customer. There is no undo: to put them back on a trial you have to clear the trial and enter the dates again, and the dates on this page are not kept.`}
    confirmText={loading ? 'Saving...' : 'Mark as converted'}
    busy={loading}
    onConfirm={onConfirm}
    onClose={onClose}
  >
    {error && (
      <div
        className="org-trial-form__error"
        role="alert"
        data-testid="org-trial-convert-error"
      >
        {error}
      </div>
    )}
  </ConfirmModal>
);
